import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer, Zoom, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer
      theme="colored"
      transition={Zoom}
      draggable
      closeOnClick
    />
    <App />
  </React.StrictMode>
);


